import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import Loading from '../../core/Loading';
import { usePermission } from '../../core/PermissionContext';

const ProtectedRoute = ({ children, requireAuth = true }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { loadingPermissions } = usePermission();
    
    useEffect(() => {
        const userUUID = Cookies.get('userUUID');
        
        if (requireAuth && !userUUID) {
            // Guarda a URL atual antes de redirecionar para login
            const currentPath = location.pathname + location.search;
            if (currentPath !== '/login') {
                sessionStorage.setItem('redirectAfterLogin', currentPath);
            }
            navigate('/login');
        }
    }, [navigate, location, requireAuth]);

    if (loadingPermissions) {
        return <Loading />;
    }

    const userUUID = Cookies.get('userUUID');
    if (requireAuth && !userUUID) {
        return null; // Não renderiza nada enquanto redireciona
    }

    return children;
};

export default ProtectedRoute; 